import React, { useState } from "react";
import Box from "@material-ui/core/Box";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Sidebar from "./Sidebar/Sidebar";

export default function Drawer({ categoryFilter }) {
	const [open, setOpen] = useState(false);

	return (
		<div>
			<IconButton
				edge="start"
				color="inherit"
				aria-label="open drawer"
				onClick={() => setOpen(true)}
			>
				<MenuIcon />
			</IconButton>
			<SwipeableDrawer
				anchor="left"
				open={open}
				onClose={() => setOpen(false)}
				onOpen={() => {}}
			>
				<div>
					<Box textAlign="center" p={2}>
						Things to help
					</Box>
					<Divider />
					<List>
						<ListItem>
							<ListItemText primary={"Filter Questions"} />
						</ListItem>
						<ListItem button onClick={() => {}}>
							<Sidebar categoryFilter={categoryFilter} />
						</ListItem>
						<ListItem onClick={() => {}}>
							<ListItemText primary={"...More to come!"} />
						</ListItem>
					</List>
				</div>
			</SwipeableDrawer>
		</div>
	);
}
